var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 58,
    viewBox: "0 0 73 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73 44.653c-2.145.557-4.516.86-7.126.86h-.563c-17.07 0-23.913-12.98-24.638-25.117a22.5 22.5 0 01-.08-1.64c.02-.27.03-.542.04-.82.01-.265.02-.536.04-.818.362-6.072 2.256-12.355 6.195-17.118h21.133a5 5 0 015 5v39.653z",
    fill: "#E9DC6C",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.132 6.606H37v30.508h28.132V6.607z",
    fill: "#F5F4F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35.3H40.077V4H69v31.3zm-28.132-.79H68.21V4.79H40.87v29.72z",
    fill: "#E9DC6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.19 21.83a1.981 1.981 0 100-3.962 1.981 1.981 0 000 3.962zm5.547 0a1.981 1.981 0 100-3.962 1.981 1.981 0 000 3.962zm5.546 0a1.981 1.981 0 100-3.962 1.981 1.981 0 000 3.962z",
    fill: "#E9DC6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.e46b90927c0ef6bd36a8222da44ad2f4.svg";
export { ForwardRef as ReactComponent };